export default [
	{
		type: 'scroll',
		slug: 'alteration',
		targets: [ 'enemy', 'hero' ],
		value: null,
		fr: {
			name: "Parchemin d'altération",
			description: "Inflige 3 dégâts au personnage ciblé."
		},
		en: {
			name: "Scroll of alteration",
			description: "Inflicts 3 damage to the targeted character."
		}
	},
	{
		type: 'scroll',
		slug: 'poison',
		targets: [ 'enemy', 'hero' ],
		value: null,
		fr: {
			name: "Parchemin de poison",
			description: "Confère (poison 3)[status-poison:3] au personnage ciblé."
		},
		en: {
			name: "Scroll of poison",
			description: "Gives (poison 3)[status-poison:3] to the targeted character."
		}
	},
	{
		type: 'scroll',
		slug: 'strength',
		targets: [ 'enemy', 'hero' ],
		value: null,
		fr: {
			name: "Parchemin de force",
			description: "Confère (force 3)[status-strength:3] au personnage ciblé."
		},
		en: {
			name: "Scroll of strength",
			description: "Gives (strength 3)[status-strength:3] to the targeted character."
		}
	},
	{
		type: 'scroll',
		slug: 'weakness',
		targets: [ 'enemy', 'hero' ],
		value: null,
		fr: {
			name: "Parchemin de faiblesse",
			description: "Confère (faiblesse 3)[status-weakness:3] au personnage ciblé."
		},
		en: {
			name: "Scroll of weakness",
			description: "Gives (weakness 3)[status-weakness:3] to the targeted character."
		}
	},
	{
		type: 'scroll',
		slug: 'vitality',
		targets: [ 'enemy', 'hero' ],
		value: null,
		fr: {
			name: "Parchemin de vitalité",
			description: "Soigne 3 points de vie au personnage ciblé."
		},
		en: {
			name: "Scroll of vitality",
			description: "Heals 3 health points to the targeted character."
		}
	},
	{
		type: 'scroll',
		slug: 'repair',
		targets: [ 'enemy', 'hero' ],
		value: null,
		fr: {
			name: "Parchemin de réparation",
			description: "Confère +1 durabilité aux équipements portés."
		},
		en: {
			name: "Scroll of repair",
			description: "Gives +1 durability to worn equipment."
		}
	},
	{
		type: 'scroll',
		slug: 'reinforcement',
		targets: [ 'weapon', 'shield' ],
		value: null,
		fr: {
			name: "Parchemin de renforcement",
			description: "Confère +2 durabilité à l'équipement ciblé."
		},
		en: {
			name: "Scroll of reinforcement",
			description: "Gives +2 durability to the targeted equipment."
		}
	},
	{
		type: 'scroll',
		slug: 'mutism',
		targets: [ 'enemy' ],
		value: null,
		fr: {
			name: "Parchemin de mutisme",
			description: "Supprime l'effet passif d'un ennemi ciblé."
		},
		en: {
			name: "Scroll of silence",
			description: "Removes the passive effect of a targeted enemy."
		}
	},
	{
		type: 'scroll',
		slug: 'wind',
		targets: [ 'enemy' ],
		value: null,
		fr: {
			name: "Parchemin de vent",
			description: "Pousse l'ennemi ciblé vers la droite."
		},
		en: {
			name: "Scroll of wind",
			description: "Pushes the targeted enemy to the right."
		}
	},
]